import { useNavigate } from 'react-router-dom'

import { Card, CardContent } from '@/shared/components/ui/card'

export default function QuoteSummaryCards({ quotations = [], stats = null }) {
  const navigate = useNavigate()
  const totalCount = stats?.total ?? quotations.length
  const openCount = stats?.open ?? 0
  const inProgressCount = stats?.in_progress ?? 0
  const wonCount = stats?.won ?? stats?.closed ?? 0

  const statItems = [
    {
      title: 'TOTAL QUOTES',
      value: totalCount,
      subtitle: 'total quotations',
      onClick: () => navigate('/sales/quotes'),
    },
    {
      title: 'OPEN',
      value: openCount,
      subtitle: 'open leads',
      onClick: () => navigate('/sales/leads?status=open'),
    },
    {
      title: 'IN PROGRESS',
      value: inProgressCount,
      subtitle: 'in progress leads',
      onClick: () => navigate('/sales/leads?status=in_progress'),
    },
    {
      title: 'WON',
      value: wonCount,
      subtitle: 'won leads',
      onClick: () => navigate('/sales/leads?status=won'),
    },
  ]

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4 sm:gap-6">
      {statItems.map((item) => (
        <Card
          key={item.title}
          onClick={item.onClick}
          className="min-h-[120px] cursor-pointer rounded-2xl border border-slate-200 shadow-sm transition-all hover:border-slate-400 hover:shadow-md active:scale-[0.98] sm:rounded-3xl"
        >
          <CardContent className="flex h-full flex-col justify-center p-4 sm:p-5">
            <p className="text-xs font-semibold tracking-[0.18em] text-slate-500 sm:text-sm">
              {item.title}
            </p>

            <h2 className="mt-2 text-xl font-bold leading-none text-slate-900 sm:mt-4 sm:text-2xl">
              {item.value}
            </h2>

            <p className="mt-2 text-xs text-slate-500 sm:mt-3 sm:text-base">
              {item.subtitle}
            </p>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
